import React from "react";

export default function ContentMedia({
  image,
  altText,
  index,
  onImageChange,
  onAltTextChange,
  error,
}) {
  return (
    <div className="mt-4">
      <label className="block mb-1 text-gray-700 font-medium">
        Add Image (optional)
      </label>

      <input
        type="file"
        accept="image/*"
        onChange={(e) => onImageChange(e, index, "Content")}
        className="mb-3"
      />

      {image && (
        <>
          <img
            src={URL.createObjectURL(image)}
            alt={altText || `Content image ${index + 1}`}
            className="w-48 h-48 mb-3 object-cover rounded-lg border shadow"
          />

          <label className="block mb-1 font-medium text-gray-800">
            Image Alt Text <span className="text-red-500">*</span>
          </label>

          <input
            type="text"
            value={altText}
            onChange={(e) => onAltTextChange(e, index)}
            placeholder="Describe the image"
            className={`border rounded-lg px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-indigo-500 ${
              error ? "border-red-500" : "border-gray-300"
            }`}
          />

          {error && (
            <p className="text-red-600 mt-1">{error}</p>
          )}
        </>
      )}
    </div>
  );
}
